import { VenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData.ts';
import React from 'react';
import { OrderLiquidityCapsuleContentPie } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/components/OrderLiquidityCapsuleContentPie';
import { OrderFillsCapsuleContentValues } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/components/OrderLiquidityCapsuleContentValues';

import './OrderLiquidityCapsuleContent.scss';
export function OrderLiquidityCapsuleContent({
    data,
}: {
    data: VenueAnalysisData;
}) {
    const orderLiquidity = data.orderLiquidity || [];

    return (
        <div className="OrderLiquidityCapsuleContent">
            <OrderLiquidityCapsuleContentPie data={orderLiquidity} />
            <OrderFillsCapsuleContentValues data={orderLiquidity} />
        </div>
    );
}
